import {
  FileProperty,
  FileSequenceInstance,
  LabelOption,
  Property,
  Tag,
  FileDto,
  User,
  WorkflowFileVersionHistory,
  WorkflowInstance,
  PopulatedFileDto,
} from 'app/types';

export enum Heartbeat {
  APP_HEARTBEAT = 'PRESENCEDOC_APP_HEARTBEAT',
  EXTENSION_HEARTBEAT = 'PRESENCEDOC_EXTENSION_HEARTBEAT',
  EXTENSION_DOCUMENT = 'PRESENCEDOC_EXTENSION_DOCUMENT',
}

export enum VersioningOptions {
  DRAFT = 'Duplicate file as Version draft',
  DRAFT_FROM_FILE = 'Add version from existing file',
}

export enum Status {
  FILLED = 'FILLED',
  MY_DRIVE = 'MY_DRIVE',
  FILE_NOT_WATCHED = 'FILE_NOT_WATCHED',
  LOADING = 'LOADING',
  UNKNOWN = 'UNKNOWN',
  NOT_FOUND = 'NOT_FOUND',
  SECRET_FILE = 'SECRET_FILE',
  OVERLAYER_NOT_ENOUGH_PERMISSION = 'OVERLAYER_NOT_ENOUGH_PERMISSION',
  UNKNOWN_FAILURE = 'UNKNOWN_FAILURE',
}

export enum DialogState {
  DESCRIPTION = 'DESCRIPTION',
  PROPERTIES = 'PROPERTIES',
  RATING = 'RATING',
  FLAG = 'FLAG',
  WORKFLOW = 'WORKFLOW',
  SECRET = 'SECRET',
  CUSTOMWORKFLOW = 'CUSTOMWORKFLOW',
  FILESEQUENCE = 'FILESEQUENCE',
  NONE = 'NONE',
}

export enum Sections {
  TITLE = 'TITLE',
  LABELS = 'LABELS',
  CONTRIBUTORS = 'CONTRIBUTORS',
  DESCRIPTION = 'DESCRIPTION',
  PROPERTIES = 'PROPERTIES',
  WORKFLOW = 'WORKFLOW',
  WORKFLOW_FILE_VERSIONS = 'WORKFLOW_FILE_VERSIONS',
  LIKE = 'LIKE',
  RATINGS = 'RATINGS',
}

export interface LikeButtonData {
  likedByMe: boolean;
  likesCount: number;
  onClick: () => void;
}

export interface SidePanel {
  connectedUser?: User;
  status: Status;
  loadingSections: Sections[];
  tags?: Tag[];
  file?: PopulatedFileDto;
  workflowInstances?: WorkflowInstance[];
  workflowFileVersionHistory?: WorkflowFileVersionHistory;
  customLabels?: Property[];
  fileCustomLabels?: FileProperty[];
  fileSequenceInstances: FileSequenceInstance[];
}

export interface SidePanelProperties {
  tags: Tag[];
  confidentiality: string;
  documentType: string;
  language: string;
  customPropertiesOptions: LabelOption[];
  customPropertiesPeople: { id: string; emails: string[] }[];
}
